export enum ActivityDisplay {
  Unknown = 0,
  DetailPages = 1,
  List = 2,
  Both = 3
}
